import axios from 'axios'
import cookie from "../../static/js/cookie";
// let host = 'http://127.0.0.1:8000/api'
let host = 'https://yoouks.cn:9002/api'

axios.interceptors.request.use(
  config => {
    if (cookie.getCookie('token')) {
      config.headers.Authorization = cookie.getCookie('token')
    }

    return config
  },
  error => {
    return Promise.reject(error)
  })


// 修改、新建教员信息
export const facultyUpdate = parmas => {
  return axios.post(`${host}/faculty-update/`, parmas)
}
// 查询教员信息
export const facultyDetail = params => {
  return axios.get(`${host}/faculty-detail/`, {params: params})
}
// 修改教员信息
export const facultyRevise = parmas => {
  return axios.post(`${host}/faculty-revise/`, parmas)
}
// 上传头像
export const facultyHead = parmas => {
  return axios.post(`${host}/faculty-head/`, parmas)
}
// 修改手机号
export const facultyPhone = parmas => {
  return axios.post(`${host}/faculty-phone/`, parmas)
}
// 修改密码
export const facultyPassword = parmas => {
  return axios.post(`${host}/faculty-password/`, parmas)
}
// 查询教员证件照
export const certificateDetail = params => {
  return axios.get(`${host}/certificate-detail/`, {params: params})
}
// 教员列表
export const facultyList = params => {
  return axios.get(`${host}/faculty-list/`, {params: params})
}
// 教员首页中小学列表
export const facultySchoolList = params => {
  return axios.get(`${host}/faculty-school-list/`, {params: params})
}
// 教员列表
export const facultyAllDetail = params => {
  return axios.get(`${host}/faculty-all-detail/`, {params: params})
}
// 修改教员证件照
export const certificateUpdate = parmas => {
  return axios.post(`${host}/certificate-update/`, parmas)
}

// 备选列表
export const facultyAlternativeList = params => {
  return axios.get(`${host}/faculty-alternative-list/`, {params: params})
}
// 备选列表
export const facultyAlternativeCount = params => {
  return axios.get(`${host}/faculty-alternative-count/`, {params: params})
}
// 添加备选
export const facultyAlternativeAdd = parmas => {
  return axios.post(`${host}/faculty-alternative-add/`, parmas)
}
// 删除备选
export const facultyAlternativeDel = parmas => {
  return axios.post(`${host}/faculty-alternative-del/`, parmas)
}


// 省份区域列表
export const provincesArea = params => {
  return axios.get(`${host}/provinces-area/`, {params: params})
}
// 省份列表
export const provincesList = params => {
  return axios.get(`${host}/provinces-list/`, {params: params})
}
// 城市列表
export const cityList = params => {
  return axios.get(`${host}/city-list/`, {params: params})
}
// 城市列表
export const cityArea = params => {
  return axios.get(`${host}/city-area/`, {params: params})
}
// 街道列表
export const street = params => {
  return axios.get(`${host}/street/`, {params: params})
}
// 更多城市列表
export const moreCity = params => {
  return axios.get(`${host}/more-city/`, {params: params})
}
// 科目列表
export const subject = params => {
  return axios.get(`${host}/subject/`, {params: params})
}
// 科目详情列表
export const subjectDetail = params => {
  return axios.get(`${host}/subject-detail/`, {params: params})
}
// 学校列表
export const univList = params => {
  return axios.get(`${host}/univ-list/`, {params: params})
}
// 价格列表
export const priceList = params => {
  return axios.get(`${host}/price-list/`, {params: params})
}

// 添加点击量
export const clickAdd = parmas => {
  return axios.post(`${host}/click-add/`, parmas)
}

// 学员提交申请
export const userTutorPost = parmas => {
  return axios.post(`${host}/user-tutor-post/`, parmas)
}
// 学员刷新申请
export const userTutorRefresh = parmas => {
  return axios.post(`${host}/user-tutor-refresh/`, parmas)
}
// 学员申请详情
export const userTutorDetail = params => {
  return axios.get(`${host}/user-tutor-detail/`, {params: params})
}
// 学员申请列表
export const userTutorList = params => {
  return axios.get(`${host}/user-tutor-list/`, {params: params})
}
// 学员申请浏览量
export const userTutorClick = params => {
  return axios.post(`${host}/user-tutor-click/`, params)
}
// 学员申请浏览量
export const userTutorAgree = params => {
  return axios.post(`${host}/user-tutor-agree/`, params)
}
// 学员成功列表
export const userSuccessList = params => {
  return axios.get(`${host}/user-success-list/`, {params: params})
}

// 教员提交申请
export const tutorUserPost = params => {
  return axios.post(`${host}/tutor-user-post/`, params)
}
// 教员操作申请同意/取消
export const tutorUserEnter = params => {
  return axios.post(`${host}/tutor-user-enter/`, params)
}
// 教员的申请记录
export const tutorUserList = params => {
  return axios.get(`${host}/tutor-user-list/`, {params: params})
}
// 教员的等待付款数量
export const payWaitCount = params => {
  return axios.get(`${host}/pay-wait-count/`, {params: params})
}
// 教员的等待付款列表
export const payWaitList = params => {
  return axios.get(`${host}/pay-wait-list/`, {params: params})
}
// 教员的成功列表
export const tutorSuccessList = params => {
  return axios.get(`${host}/tutor-success-list/`, {params: params})
}

// 退款
export const refundPost = params => {
  return axios.post(`${host}/refund-post/`, params)
}
// 投诉建议
export const complainPost = params => {
  return axios.post(`${host}/complain-post/`, params)
}
// 评分
export const starPost = params => {
  return axios.post(`${host}/star-faculty/`, params)
}
// 评分列表
export const starGet = params => {
  return axios.get(`${host}/star-faculty/`, {params: params})
}

// 新闻列表
export const newsList = params => {
  return axios.get(`${host}/news-list/`, {params: params})
}
// 新闻详情
export const newsDetail = params => {
  return axios.get(`${host}/news-detail/`, {params: params})
}
// 价格详情
export const priceDetail = params => {
  return axios.get(`${host}/price-detail/`, {params: params})
}
// 数量总计
export const allCount = params => {
  return axios.get(`${host}/all-count/`, {params: params})
}
// 已阅
export const allRead = params => {
  return axios.get(`${host}/all-read/`, {params: params})
}
// 会员价格列表
export const payNumber = params => {
  return axios.get(`${host}/pay-number/`, {params: params})
}
// 改变支付金额、包月、永久
export const changePay = params => {
  return axios.post(`${host}/change-pay/`, params)
}


// 微信支付轮询
export const wechatStatus = params => {
  return axios.get(`${host}/wechat_status/`, {params: params})
}

// 积分充值
// 生成订单
export const userIntegral = params => {
  return axios.get(`${host}/user-integral/`, {params: params})
}

// 微信支付轮询
export const integralWechatStatus = params => {
  return axios.get(`${host}/integral_wechat_status/`, {params: params})
}

// 密码错误次数管理
export const errorManageList = params => {
  return axios.get(`https://uukasi.com/error-manage-list/`, {params: params})
}



// WEBPACK FOOTER //
// ./src/config/axioUtil.js